export default __webpack_public_path__ + "static/media/quimicos_banner.38ada088.png";